import { connect } from "react-redux";
import SocialActivityEditor from "../components/SocialActivityEditor";
import { fetchActivity, fetchSingleNote, fetchSingleTopic, logDebugMessage, logError, sendAlert } from "../actions";
import { isSlideAvailable } from "../utils/helpers";
import { find } from "lodash";
var mapStateToProps = function(state, _ownProps) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter" && isSlideAvailable(n, state);
    });
    return {
        currentSlide: find(state.nodes, function(n) {
            return n.id === state.currentSlide;
        }),
        slides: slides
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        sendDebugMessage: function(message, messageType, label) {
            dispatch(logDebugMessage({
                message: message,
                messageType: messageType,
                label: label
            }));
        },
        logError: function(message, key) {
            dispatch(logError({
                error: new Error(message),
                key: key
            }));
        },
        sendAlert: function(message, messageType, timeout) {
            dispatch(sendAlert({
                message: message,
                messageType: messageType,
                timeout: timeout
            }));
        },
        fetchNote: function(note) {
            dispatch(fetchSingleNote({
                note: note
            }));
        },
        fetchTopic: function(topic) {
            dispatch(fetchSingleTopic({
                topic: topic
            }));
        },
        fetchActivity: function(activity, topic) {
            dispatch(fetchActivity({
                activity: activity,
                topic: topic
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialActivityEditor);
